import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ScormContentsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.ContentFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type ScormContentsQuery = { contents: { edges?: Array<{ node: { id: string, name: string, duration: number, cover?: { url?: string | null } | null } | {} }> | null } };


export const ScormContentsDocument = /*#__PURE__*/ gql`
    query scormContents($filters: ContentFilters, $sort: [SortType!]) {
  contents(filters: $filters, sort: $sort) {
    edges {
      node {
        ... on ScormContentType {
          id
          name
          duration
          cover {
            url
          }
        }
      }
    }
  }
}
    `;

export function useScormContentsQuery(options?: Omit<Urql.UseQueryArgs<ScormContentsQueryVariables>, 'query'>) {
  return Urql.useQuery<ScormContentsQuery, ScormContentsQueryVariables>({ query: ScormContentsDocument, ...options });
};